import React, { FC, useContext } from "react";

import { Paper } from "@mui/material";

import { UserContext } from "../contexts/UserContext";
import { useSettings } from "../hooks/use-settings";
import { QuestionMarkCircle } from "./icons";
import { Button } from "./ui/button";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import sendStandardEvent from "@/hooks/use-firebase-event";
import { cn } from "@/lib/utils";

type FeatureHintProps = React.PropsWithChildren<{
  hintId: string;
  title: string;
  learnMoreLink: string;
}>;
const FeatureHint: FC<FeatureHintProps> = ({
  hintId,
  title,
  learnMoreLink,
  children,
}) => {
  const settings = useSettings();
  const { user } = useContext(UserContext);
  return (
    <Paper>
      <Accordion
        type="single"
        onValueChange={(value: string) => {
          if (value) {
            sendStandardEvent("hint_opened", hintId, user);
          }
        }}
        collapsible
        className="my-4"
      >
        <AccordionItem
          value={`${hintId}_hint`}
          className="px-4 py-2 !border last:!border border-info rounded-lg"
        >
          <AccordionTrigger>
            <span className="flex gap-2 items-center">
              <QuestionMarkCircle color="info" aria-hidden="true" />
              {title}
            </span>
          </AccordionTrigger>
          <AccordionContent
            className={cn(
              "prose prose-sm w-full max-w-none",
              settings.paletteMode === "dark" && "prose-invert",
            )}
          >
            {children}
            <Button
              variant="default"
              className="justify-self-end no-underline"
              asChild
            >
              <a href={learnMoreLink} target="_blank">
                Learn More
              </a>
            </Button>
          </AccordionContent>
        </AccordionItem>
      </Accordion>
    </Paper>
  );
};
export default FeatureHint;
